import { getBuffer } from '@dynamic-labs-sdk/client/core';
import type { Network, Psbt } from 'bitcoinjs-lib';
import { payments } from 'bitcoinjs-lib';

import { SegwitOutputScriptError } from '../../../errors/SegwitOutputScriptError';
import { RBF_SEQUENCE } from '../../constants';
import type { UTXO } from '../../WaasBitcoinWalletProvider.types';

type AddInputsToPsbtOptions = {
  network: Network;
  psbt: Psbt;
  publicKeyPair: { publicKey: Uint8Array };
  selectedUTXOs: UTXO[];
};

/**
 * Adds inputs to PSBT from selected UTXOs
 *
 * @param options.network - Bitcoin network configuration (mainnet or testnet)
 * @param options.psbt - The PSBT instance to add inputs to
 * @param options.publicKeyPair - Key pair containing the public key for witness script
 * @param options.selectedUTXOs - Array of UTXOs to add as inputs
 */
export const addInputsToPsbt = (options: AddInputsToPsbtOptions): void => {
  const { network, psbt, publicKeyPair, selectedUTXOs } = options;

  for (const utxo of selectedUTXOs) {
    const outputScript = payments.p2wpkh({
      network,
      pubkey: publicKeyPair.publicKey,
    }).output;

    if (!outputScript) {
      throw new SegwitOutputScriptError();
    }

    const txidBuffer = new Uint8Array(
      getBuffer().from(utxo.txid, 'hex').reverse()
    );

    psbt.addInput({
      hash: txidBuffer,
      index: utxo.vout,
      sequence: RBF_SEQUENCE,
      witnessUtxo: {
        script: outputScript,
        value: BigInt(utxo.value),
      },
    });
  }
};
